import $ from 'jquery';
import 'bootstrap';
import { initComponents } from './componentList';
import { debounce, throttle } from './utils';
import QuoteModal from './components/QuoteModal';
import Gallery from './components/Gallery';

// Initialize on DOM ready
$(document).ready(function() {
    initComponents();
    initHeader();
    initMobileMenu();
    initSearch();
    initLogoSwitch();
    initGallery();
    
    // Initialize Quote Modal
    new QuoteModal();
});

// Header functionality
function initHeader() {
    const header = $('.header');
    let lastScroll = 0;
    
    $(window).on('scroll', throttle(function() {
        const currentScroll = $(this).scrollTop();
        
        if (currentScroll > 100) {
            header.addClass('scrolled');
        } else {
            header.removeClass('scrolled');
        }
        
        // Hide/show header on scroll
        if (currentScroll > lastScroll && currentScroll > 200) {
            header.addClass('header-hidden');
        } else {
            header.removeClass('header-hidden');
        }
        
        lastScroll = currentScroll;
    }, 100));
    
    // Set header height CSS variable
    function setHeaderHeight() {
        const headerHeight = header.outerHeight();
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
    
    setHeaderHeight();
    $(window).on('resize', debounce(setHeaderHeight, 250));
}

// Mobile menu
function initMobileMenu() {
    const menuTrigger = $('.menu-trigger');
    const mobileMenuClose = $('.mobile-menu-close');
    const mobileMenu = $('.mobile-menu-navigation-holder');
    const overlay = $('.overlay');
    
    menuTrigger.on('click', function(e) {
        e.preventDefault();
        $('body').addClass('mobile-menu-open');
        mobileMenu.addClass('active');
        overlay.addClass('active');
    });
    
    function closeMenu() {
        $('body').removeClass('mobile-menu-open');
        mobileMenu.removeClass('active');
        overlay.removeClass('active');
    }
    
    mobileMenuClose.on('click', closeMenu);
    overlay.on('click', closeMenu);
    
    // Close on escape key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('body').hasClass('mobile-menu-open')) {
            closeMenu();
        }
    });
}

// Search functionality
function initSearch() {
    const searchTrigger = $('.search-trigger');
    const searchWrap = $('.search-wrap');
    const searchField = searchWrap.find('input[type="search"]');
    
    searchTrigger.on('click', function(e) {
        e.preventDefault();
        searchWrap.toggleClass('active');
        if (searchWrap.hasClass('active')) {
            searchField.focus();
        }
    });
    
    // Close search on outside click
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.search-wrap, .search-trigger').length) {
            searchWrap.removeClass('active');
        }
    });
}

// Logo switch for mobile/desktop
function initLogoSwitch() {
    const logo = $('.site-logo');
    
    if (!logo.length) return;
    
    const desktopLogo = logo.data('desktop');
    const mobileLogo = logo.data('mobile');
    
    if (!desktopLogo || !mobileLogo) return;
    
    function switchLogo() {
        if ($(window).width() < 768) {
            logo.attr('src', mobileLogo);
        } else {
            logo.attr('src', desktopLogo);
        }
    }
    
    switchLogo();
    $(window).on('resize', debounce(switchLogo, 250));
}

// Smooth scroll for anchor links
$('a[href^="#"]').on('click', function(e) {
    const target = $(this.getAttribute('href'));
    
    if (target.length) {
        e.preventDefault();
        $('html, body').stop().animate({
            scrollTop: target.offset().top - 100
        }, 600);
    }
});

// Back to top button
$(window).on('scroll', throttle(function() {
    if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn();
    } else {
        $('.back-to-top').fadeOut();
    }
}, 200));

$('.back-to-top').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 600);
});


// Gallery functionality
function initGallery() {
    const galleryGrid = document.getElementById('galleryGrid');
    if (galleryGrid) {
        new Gallery(galleryGrid);
    }
}
